<template>
	<div class="gift_promo">
		<!-- <pre>
      100PERCENT - It works with Test Activity

      25off - Test Activity (edited)

      GuestLimit4 - Mountain Biking
    </pre> -->

		<!-- <a href class="flex" @click.prevent="toggle">
      <h4>Use a promo code</h4>
      <div class="flex">
        <span
          v-if="order && order.OrderPromoCodes && order.OrderPromoCodes.length"
          class="badge"
          >{{ order.OrderPromoCodes.length }}</span
        >
        <span class="chevron" :class="{ up: openPromo }" />
      </div>
    </a> -->

		<!-- <transition name="slide-vertical"> -->
		<div class="_container" style="display: grid;">
			<form id="promo_form" class="flex" @submit.prevent="applyPromo">
				<fieldset>
					<input
						type="text"
						placeholder="Enter Promo Code"
						v-model="discount.value"
					/>
				</fieldset>
				<button
					:disabled="discount.ajaxing || discount.value == ''"
					type="submit"
					class="blue"
					:class="{ button_loading: discount.ajaxing }"
				>
					Apply
				</button>
			</form>
			<transition name="slide-vertical">
				<p v-show="discount.error" class="flex_start error">
					<i class="material-icons mr-1">error</i>
					<span v-for="err in discount.error" v-bind:key="err">{{ err }}</span>
				</p>
			</transition>
			<transition name="slide-vertical">
				<p
					v-show="discount.messages"
					class="pl-1 pr-1 pt-1 pb-1 mb-1 border_radius flex_start message text_size-small"
				>
					<span
						v-for="msg in discount.messages"
						v-bind:key="msg"
						style="display: grid"
						>{{ msg }}</span
					>
				</p>
			</transition>
			<transition name="slide-vertical">
				<loader class="mb-1" v-if="removeLoading && order.OrderPromoCodes" />
			</transition>
			<div class="flex_start wrap_tags">
				<span
					v-for="promo in order.OrderPromoCodes"
					class="promo_tag"
					:key="promo.OrderPromoCodeKey"
				>
					<div class="flex">
						<span>{{ promo.PromoCode }}</span>

						<!-- <button
                :disabled="removeLoading"
                class="delete_button"
                @click.prevent="resetPromo(promo.OrderPromoCodeKey)"
              /> -->
						<a
							class="delete_button"
							@click.prevent="resetPromo(promo.OrderPromoCodeKey)"
						></a>
					</div>
				</span>
			</div>
		</div>
		<!-- </transition> -->
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import { gzip } from 'node-gzip';
	import Loader from './Loader.vue';

	export default {
		name: 'GiftPromo',
		//props: ["type"],
		data() {
			return {
				openPromo: false,
				promoMessage: false,
				removeLoading: false,
			};
		},
		computed: {
			...mapState(['discount', 'order']),
		},

		components: {
			Loader,
		},

		mounted() {
			this.$set(this.discount, 'error', false);
		},

		methods: {
			toggle() {
				this.openPromo = !this.openPromo;
			},
			applyPromo: async function() {
				if (this.removeLoading || this.discount.ajaxing) {
					return;
				}
				this.PromoError = false;
				//this.PromoApplied = false;

				let data = {
					ClientLocationKey: this.$route.params.client,
					OrderKey: this.$store.state.order.OrderKey,
					PromoCode: this.discount.value,
				};

				if (this.discount.value) {
					this.$set(this.discount, 'ajaxing', true);
					this.$set(this.discount, 'error', false);
					this.$set(this.discount, 'messages', false);

					this.promoMessage = false;

					// eslint-disable-next-line no-undef
					$.ajax({
						type: 'POST',
						url: this.$store.state.serverPath + '/AddPromoCode',
						contentType: 'application/json',
						data: await gzip(JSON.stringify(data)).then((z) => {
							return z;
						}),
						processData: false,
						headers: {
							'Content-Encoding': 'gzip',
						},
						cache: false,
						success: (json) => {
							this.$set(this.discount, 'ajaxing', false);
							this.$set(this.discount, 'value', '');

							if (json.Applied == false) {
								if (json.ExceptionMessage) {
									this.$set(this.discount, 'error', [json.ExceptionMessage]);
								} else {
									this.$set(this.discount, 'error', json.Messages);
								}
							} else {
								if (json.Messages && json.Messages.length > 0) {
									this.$set(this.discount, 'messages', json.Messages);
								}
								this.$store.commit('updateOrder', json.Order);
								this.promoMessage = json.Message;
							}

							// this.loading = false;
							// this.$store.commit("updatePromoMessage", json.Message);
							// if (json.Applied == false) {
							//   this.PromoError = true;
							//   this.PromoApplied = false;
							// } //
							// else {
							//   this.PromoApplied = true;
							//   this.$store.commit("updateOrder", json.Order);
							// }
							// this.$store.commit("updatePromoCode", null);
							// setTimeout(() => {
							//   this.$emit("resetCartHeight", {});
							// }, 100);
							// this.$store.commit("hideLoader");
						}, //success

						error: (msg) => {
							console.warn(msg);
							this.$set(this.discount, 'ajaxing', false);
						},

						done: () => {
							//this.$store.commit("hideLoader");
							//this.loading = false;
						},
					}); // ajax
				}
				//
				else {
					console.warn('No promo code entered.');
					this.PromoError = true;
				}
			}, // applyPromo

			resetPromo: async function(orderPromoCodeKey) {
				if (this.removeLoading || this.discount.ajaxing) {
					return;
				}
				this.PromoError = false;
				//this.PromoApplied = false;
				this.removeLoading = true;

				this.promoMessage = false;

				this.$set(this.discount, 'value', '');
				this.$set(this.discount, 'error', false);
				this.$set(this.discount, 'messages', false);

				var data = {
					ClientLocationKey: this.$route.params.client,
					OrderKey: this.order.OrderKey,
					OrderPromoCodeKey: orderPromoCodeKey, //this.promo.OrderPromoCodeKey
				};

				// eslint-disable-next-line no-undef
				$.ajax({
					type: 'POST',
					url: this.$store.state.serverPath + '/DeletePromoCode',
					contentType: 'application/json',
					data: await gzip(JSON.stringify(data)).then((z) => {
						return z;
					}),
					processData: false,
					headers: {
						'Content-Encoding': 'gzip',
					},
					cache: false,
					success: (json) => {
						//if (json.Order) {
						this.$store.commit('updateOrder', json.Order);
						//}

						this.removeLoading = false;
					}, //success

					error: (msg) => {
						this.removeLoading = false;
						console.warn(msg);
						//this.$store.commit("hideLoader");
					},
				}); // ajax
			}, // resetPromo
		},
	};
</script>

<style lang="scss">
	.message {
		border: 1px solid #ddd;
		color: gray;
		font-size: small;
		flex-direction: column;
	}
	.message span {
		margin: 3px 0px;
	}
</style>
